import * as T from '../constants/types';
import * as V from '../constants/variables';

const throwNotification = notification => (dispatch, getState) => {
    const { notifications } = getState();
    dispatch({ type: T.THROW_NOTIFICATION, payload: [ notification, ...notifications ] });
};

export const throwError = ({ message }, actionType) => dispatch => {
    dispatch(throwNotification({ type: V.ERROR_NOTIFICATION, message, actionType, timeStamp: new Date().toISOString() }));
};
